import { useTranslation } from '@conekta/cronos/i18n';
import FieldEvaluated from 'app/pages/frames/components/Form/FieldEvaluated';
import { getFormControlProps } from 'app/pages/frames/components/Form/FieldEvaluated/helpers';

import { formControlsPropsCustomer, formCustomerFieldNames } from './constants';
import './FormCustomer.scss';

export const FormCustomer = () => {
  const { t } = useTranslation();
  const { name, email } = formCustomerFieldNames;

  return (
    <div className="FormCustomer">
      <FieldEvaluated {...getFormControlProps(name, formControlsPropsCustomer, t)} />
      <FieldEvaluated {...getFormControlProps(email, formControlsPropsCustomer, t)} />
    </div>
  );
};
